import React, { FC } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import ChatLayout from 'buyside/components/presentation/ChatLayout/chatLayout';
import ErrorBoundary from 'buyside/components/presentation/ErrorBoundary/errorBoundary';
import { ChatContext } from 'buyside/components/presentation/ChatLayout/chatLayout';

import useSectorNavigation from 'buyside/components/presentation/ChatLayout/ChatNavigation/useSectorNavigation';

import { sectorChatsUrl } from 'buyside/util/urlHelper';

const SectorChatsPageRoot: FC<{
  canManageMessages: string;
  canViewIdeas: string;
  currentUserId: string;
}> = ({ canManageMessages, canViewIdeas, currentUserId }) => {
  return (
    <ErrorBoundary pageName="sector chats">
      <Router basename={sectorChatsUrl()}>
        <Routes>
          <Route
            path="/:chatId?"
            element={
              <ChatContext.Provider
                value={{
                  canManageMessages: canManageMessages === 'true',
                  canViewIdeas: canViewIdeas === 'true',
                  currentUserId,
                  useChatNavigation: useSectorNavigation
                }}
              >
                <ChatLayout />
              </ChatContext.Provider>
            }
          />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default SectorChatsPageRoot;
